import React, {
  // forwardRef,
  // ReactElement,
  // Ref,
  useEffect,
  useState
} from 'react'
import { useNavigate } from 'react-router-dom'
import { Logout, Settings } from '@mui/icons-material'
import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import AuthAPI from 'api/orbitV1/AuthAPI'
import profilePlaceholder from 'assets/placeholders/profile_placeholder.png'
import { PictureWrapper } from 'common/ui/colorBox'
import OrbitSession from 'hooks/useCookies'
import PropTypes from 'prop-types' // Profile picture placeholder

import packageInfo from '../../../../../package.json'

// const Transition = forwardRef(function Transition(
//   props: TransitionProps & {
//     // eslint-disable-next-line @typescript-eslint/no-explicit-any
//     children: ReactElement<any, any>
//   },
//   ref: Ref<unknown>
// ) {
//   return <Slide direction='up' ref={ref} {...props} />
// })

export default function NavbarProfileMenu({ toggled }) {
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState(null)
  const [profilePic, setProfilePic] = useState<string>('')
  const [userName, setUserName] = useState<string>('')
  const [backendVersion, setBackendVersion] = useState<string>('')
  const currRole = OrbitSession.get('role')

  const open = Boolean(anchorEl)
  const handleClick = (e) => {
    setAnchorEl(e.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    setUserName(OrbitSession.get('userName'))
    setBackendVersion(OrbitSession.get('backendVersion'))
    OrbitSession.setStoreType('localstorage')
    const profilePicUrl = OrbitSession.get('profileImg')
    OrbitSession.setStoreType('cookie')
    profilePicUrl
      ? setProfilePic('data:image/png;base64,' + profilePicUrl)
      : setProfilePic(profilePlaceholder)
  }, [])

  const logout = () => {
    OrbitSession.delAll()
    OrbitSession.setStoreType('localstorage')
    OrbitSession.del('profileImg')
    OrbitSession.setStoreType('cookie')
    try {
      AuthAPI.logUserOut()
    } finally {
      navigate('/login')
    }
  }

  const menuItems = [
    {
      clickHandler: () => navigate('profile'),
      icon: <Settings fontSize='small' />,
      label: 'Settings',
      role: ['ops', 'owner', 'opsowner', 'admin', 'opsviewer', 'external']
    },
    {
      clickHandler: logout,
      icon: <Logout fontSize='small' data-cy='logout' />,
      label: 'Logout',
      role: ['ops', 'owner', 'opsowner', 'admin', 'opsviewer', 'external']
    }
  ]

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginLeft: 3
        }}
      >
        {toggled && (
          <Typography sx={{ color: 'white', margin: 0 }}>
            <b>{userName}</b>
          </Typography>
        )}
        <div id='sideNavBar_profileIcon'>
          <Tooltip title='Account settings' placement='right'>
            <IconButton
              onClick={handleClick}
              size='small'
              sx={{ ml: 2 }}
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup='true'
              aria-expanded={open ? 'true' : undefined}
              data-cy='navIcon'
            >
              <PictureWrapper
                style={{
                  width: 32,
                  height: 32
                }}
                image={profilePic}
              />
            </IconButton>
          </Tooltip>
        </div>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id='account-menu'
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              mr: 1
            },
            // Revert to previous exact width
            width: '167.28px'
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem disabled>
          <Avatar alt={userName} src={profilePic} /> {userName}
        </MenuItem>

        <Divider light sx={{ width: '100%', height: '0.2px', margin: 0 }} />

        {menuItems.map(({ clickHandler, icon, label, role }, index) => {
          if (role.includes(currRole)) {
            return (
              <MenuItem
                id={label}
                key={`${label}-${index}`}
                onClick={clickHandler}
                data-cy={label}
              >
                <ListItemIcon>{icon}</ListItemIcon>
                {label}
              </MenuItem>
            )
          } else {
            return ''
          }
        })}

        <MenuItem disabled>
          <Typography
            sx={{
              color: 'black',
              margin: 0,
              borderTop: '1px solid white'
            }}
          >
            <strong>b</strong>: v{backendVersion} <strong>f</strong>: v
            {packageInfo.version}
          </Typography>
        </MenuItem>
      </Menu>
    </>
  )
}

NavbarProfileMenu.propTypes = {
  toggled: PropTypes.bool
}
